import { Filter } from '@classify/react-core-components/FilterContainer';

function mapFiltersToMenu(filters: Filter[]) {
  const hasFilters = filters.some((filter) => filter.checkedItems.length > 0);
  if (!hasFilters) {
    return undefined;
  }
  return filters.reduce((acc, filter) => {
    const { name, checkedItems } = filter;
    const firstCheckedValue = checkedItems[0];
    if (!firstCheckedValue) {
      return acc;
    }
    return {
      ...acc,
      [name]: firstCheckedValue.value,
    };
  }, {} as Record<string, string>);
}
export default mapFiltersToMenu;
